<template>
<div class='table-items-in-view'>
  <b-field :label="locLabel">
    <b-select v-model='value' @input='notify' :placeholder="locPlaceholder">
      <option
        v-for="option in options"
        :value="option"
        :key="option">
        {{ option }}
      </option>
    </b-select>
  </b-field>
</div>
</template>

<script>

import { PER_PAGE_VALUE, TEXTS } from '@/configuration/clientTableConf';

export default {
  name: 'TableItemsInView',
  props: ['label', 'placeholder', 'perPage'],
  data() {
    return {
      options: PER_PAGE_VALUE,
      value: PER_PAGE_VALUE[0],
    };
  },
  methods: {
    notify(value) {
      this.$emit('input', value);
    },
  },
  computed: {
    locLabel() {
      return this.label ? this.label : this.$i18n.t(TEXTS.limit);
    },
    locPlaceholder() {
      return this.placeholder ? this.placeholder : '<Resultats par page>';
    },
  },
  mounted() {
    if (this.perPage) this.value = this.perPage;
  },
};
</script>
